import type { ExternalTableSchema } from '@packages/table-builder';

export const taxPeriodTable: ExternalTableSchema = {
  metadata: {
    title: 'Tax Period',
    entity: 'tax-period',
    description: 'View all tax periods for your organization.',
  },
  dataSource: {
    endpoint: '/api/tax/api/app/tax-period/paged-sorted-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: { items: 'items', totalCount: 'totalCount' },
  },
  columns: [
    { field: 'name', header: 'Tax Period Name', type: 'text', width: 200, sortable: true },
    {
      field: 'effectiveFrom',
      header: 'Tax Period',
      type: 'dateRange',
      width: 200,
      sortable: false,
      dateRange: { startField: 'effectiveFrom', endField: 'effectiveTill' },
    },
  ],
  actions: {
    row: [
      { id: 'VIEW_TAX_PERIOD', label: 'View' },
      { id: 'EDIT_TAX_PERIOD', label: 'Edit' },
    ],
  },
  features: {
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
    toolbar: { enabled: false },
  },
};
